import React, { useEffect, useCallback, useState, useRef } from 'react';
import { FullScreen, useFullScreenHandle } from 'react-full-screen';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import { IconButton, Tooltip, TextField } from '@material-ui/core';
import { OpenInNew } from '@material-ui/icons';
import { Autocomplete } from '@material-ui/lab';
import api from 'axios';
import { isNull, isArray } from 'lodash';

import { Islands } from '~/componentsLocal';
import { t } from '~/helpers';

import * as S from './styles';

export default function SinoticoDescarregamento() {
  const handle = useFullScreenHandle();
  const modalRef = useRef(null);

  const [data, setData] = useState([]);
  const [postos, setPostos] = React.useState([]);
  const [posto, setPosto] = React.useState(null);
  const [idposto, setIdPosto] = React.useState(null);

  const token = useSelector((state) => state.auth);

  const handleRequestAPI = useCallback(
    async (idposto) => {
      try {
        const request = idposto
          ? await api.get(
              `${process.env.REACT_APP_URL_REQUEST}descargasnfs/sinotico/posto/${idposto}`,
              {
                headers: {
                  'Current-Route': window.location.pathname,
                  Authorization: 'Bearer ' + `${token.token}`,
                },
              }
            )
          : await api.get(
              `${process.env.REACT_APP_URL_REQUEST}descargasnfs/sinotico`,
              {
                headers: {
                  'Current-Route': window.location.pathname,
                  Authorization: 'Bearer ' + `${token.token}`,
                },
              }
            );
        setData(request.data);
      } catch (error) {
        if (isArray(error)) error.map((err) => toast.error(t(err)));
        else toast.error(t(error));
      }
    },
    [idposto]
  );

  React.useEffect(() => {
    handleGetPostosComboios();
  }, []);

  const handleGetPostosComboios = React.useCallback(async () => {
    const params = { pagesize: 9999, statusposto: 'L', pesquisalista: true };
    try {
      const { data } = await api.get(
        `${process.env.REACT_APP_URL_REQUEST}postoscomboios`,
        {
          params,
          headers: {
            'Current-Route': window.location.pathname,
            Authorization: 'Bearer ' + `${token.token}`,
          },
        }
      );
      setPostos(data.items);
    } catch (err) {
      if (isArray(err)) err.map((e) => toast.error(t(e)));
      else toast.error(t(err));
    } finally {
      //
    }
  }, []);

  const handleChangeAutocomplete = React.useCallback(
    (value) => {
      if (isNull(value)) {
        handleResetVars();
      } else {
        const { idposto } = value;
        setPosto(value);
        setIdPosto(idposto);
        // carrega os dados
        handleRequestAPI(idposto);
      }
    },
    [idposto]
  );

  const handleResetVars = React.useCallback(() => {
    setPosto(null);
    setIdPosto(null);
  }, []);

  useEffect(() => {
    handleRequestAPI(idposto);
  }, [idposto]);

  useEffect(() => {
    const timeOut = setInterval(() => {
      handleRequestAPI(idposto);
    }, 15000);

    return () => clearInterval(timeOut);
  }, [idposto]);

  const handleOpenNewWindow = () => {
    window.open(
      '/sinoticodescarregamentosfull',
      '_blank',
      'toolbar=0,location=0,menubar=0'
    );
  };

  return (
    <S.WrapperFullScreen>
      <header>
        <Tooltip title="FullScreen">
          <IconButton
            color="primary"
            size="small"
            onClick={() => handleOpenNewWindow()}
          >
            <OpenInNew />
          </IconButton>
        </Tooltip>
      </header>

      <FullScreen handle={handle}>
        <S.Wrapper fullScreen={handle.active}>
          <Autocomplete
            options={postos}
            value={posto}
            getOptionLabel={(posto) => `${posto.codigonomeposto}`}
            size="small"
            style={{ width: '100%' }}
            fullWidth
            onChange={(e, value) => handleChangeAutocomplete(value)}
            renderInput={(params) => (
              <TextField
                {...params}
                label={t('s.operacao.abastecimento.nomeposto')}
                variant="outlined"
                size="small"
                fullWidth
                style={{ marginTop: 10 }}
              />
            )}
          />
        </S.Wrapper>
        <S.Wrapper>
          {data?.map((item) => (
            <Islands
              key={Math.random().toString()}
              data={item}
              idposto={item.idposto}
              modalRef={modalRef}
            />
          ))}
        </S.Wrapper>
      </FullScreen>
    </S.WrapperFullScreen>
  );
}
